import { CommunicationEntityDomain } from "@hd/types/dto/communication/communication-entity-domain";
import { CommunicationTypeEnum } from "@hd/types/dto/communication/communication-type.enum";
import { create } from "zustand";

export interface CommunicationsModalState {
  isOpen: boolean;
  canEditContactEmail: boolean;

  groupId: number | null; // mandatory
  companyId: number | null;
  contactId: number | null; // mandatory

  entityDomain: CommunicationEntityDomain | null;
  entityId: string | null;

  actionCode: string | null;
  communicationType: CommunicationTypeEnum | null;

  // bozze dei tab: stanno qui perché il pannello non attivo viene smontato
  // e il bottone Invia della modale le deve poter leggere
  emailBody: string;
  emailRecipients: string[];
  whatsappPhoneNumber: string | null;

  setEmailBody(body: string): void;
  setEmailRecipients(recipients: string[]): void;
  setWhatsappPhoneNumber(phoneNumber: string | null): void;

  open(
    canEditContactEmail: boolean,

    groupId: number,
    companyId: number,
    contactId: number,

    entityDomain: CommunicationEntityDomain | null,
    entityId: string | null,

    actionCode: string | null,
    communicationType: CommunicationTypeEnum | null,
  ): void;
  close(): void;
}

// un posto solo: se aggiungo una bozza va azzerata sia all'apertura che alla chiusura
const EMPTY_DRAFTS = {
  emailBody: "",
  emailRecipients: [] as string[],
  whatsappPhoneNumber: null as string | null,
};

export const useCommunicationsModalStore = create<CommunicationsModalState>(
  (set) => {
    return {
      isOpen: false,
      canEditContactEmail: false,

      groupId: null,
      companyId: null,
      contactId: null,

      entityDomain: null,
      entityId: null,

      actionCode: null,
      communicationType: null,

      ...EMPTY_DRAFTS,

      setEmailBody: (emailBody: string) => set(() => ({ emailBody })),
      setEmailRecipients: (emailRecipients: string[]) =>
        set(() => ({ emailRecipients })),
      setWhatsappPhoneNumber: (whatsappPhoneNumber: string | null) =>
        set(() => ({ whatsappPhoneNumber })),

      open: (
        canEditContactEmail: boolean,

        groupId: number,
        companyId: number,
        contactId: number,

        entityDomain: CommunicationEntityDomain | null,
        entityId: string | null,

        actionCode: string | null,
        communicationType: CommunicationTypeEnum | null,
      ) =>
        set(() => ({
          isOpen: true,
          canEditContactEmail,

          groupId,
          companyId,
          contactId,

          entityDomain,
          entityId,

          actionCode,
          communicationType,

          ...EMPTY_DRAFTS,
        })),

      close: () =>
        set(() => ({
          isOpen: false,
          canEditContactEmail: false,

          groupId: null,
          companyId: null,
          contactId: null,

          entityDomain: null,
          entityId: null,

          actionCode: null,
          communicationType: null,

          ...EMPTY_DRAFTS,
        })),
    };
  },
);
